import React, { memo, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

const Modal = memo(({ isOpen, onClose, title, children, isCenter }) => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true); // Ensure this runs only in the browser
  }, []);

  if (!isMounted || !isOpen) return null;

  const modalClass = `fixed inset-0 flex justify-center items-start pt-10 bg-gray-800 bg-opacity-60 z-[1000]`; // backdrop
  const modalContentClass = `absolute top-10 bg-white px-10 py-10 rounded-xl shadow-2xl min-w-screen max-h-screen overflow-auto z-[9999]`; // modal box

  const modalHeaderClass = 'flex justify-between items-center mb-5';
  const modalTitleClass = 'font-semibold text-2xl';
  const modalCloseButtonClass = 'text-3xl font-bold text-black';
  const modalContentWrapperStyle = {
    maxHeight: 'calc(100vh - 200px)',
    overflowY: 'auto',
  };

  return createPortal(
    <div className={modalClass}>
      <div className={modalContentClass}>
        <div className={modalHeaderClass}>
          <div>{title && <h2 className={modalTitleClass}>{title}</h2>}</div>
          <div>
            <button className={modalCloseButtonClass} onClick={onClose}>
              &times;
            </button>
          </div>
        </div>
        <div
          className="modal-content-wrapper overflow-x-clip"
          style={modalContentWrapperStyle}
        >
          {children}
        </div>
      </div>
    </div>,
    document.body, // ✅ portal root
  );
});

export default Modal;
